import messages from '../../../../messages';

export const DEFAULTS = {
  behavior: 'static',
  intervalSeconds: 5,
  columns: 'one',

  row1ColorLeft: 'black',
  row2ColorLeft: 'black',
  row3ColorLeft: 'black',

  row1ColorRight: 'black',
  row2ColorRight: 'black',
  row3ColorRight: 'black',

  row1ColorThird: 'black',
  row2ColorThird: 'black',
  row3ColorThird: 'black',
};

const Schema = (props) => {
  const { intl } = props;
  const data = props?.data || props?.formData || {};

  const behavior = data.behavior || DEFAULTS.behavior;
  const columns = data.columns || DEFAULTS.columns;

  const showInterval = behavior === 'interval';
  const showSecondColumn = columns === 'two' || columns === 'three';
  const showThirdColumn = columns === 'three';

  const colorTitle = intl.formatMessage(messages.brandColorTitle);
  const colorDescription = intl.formatMessage(messages.brandColorDescription);
  const columnLabel = intl.formatMessage(messages.brandColumnLabel);

  const baseFields = ['columns', 'behavior'];
  if (showInterval) {
    baseFields.push('intervalSeconds');
  }

  const rowFieldsLeft = ['row1ColorLeft', 'row2ColorLeft', 'row3ColorLeft'];
  const rowFieldsRight = ['row1ColorRight', 'row2ColorRight', 'row3ColorRight'];
  const rowFieldsThird = [
    'row1ColorThird',
    'row2ColorThird',
    'row3ColorThird',
  ];

  const fieldsets = [
    {
      id: 'default',
      title: intl.formatMessage(messages.brandSettings),
      fields: baseFields,
    },
    {
      id: 'column1',
      title: `${colorTitle} – 1. ${columnLabel}`,
      fields: rowFieldsLeft,
    },
  ];

  if (showSecondColumn) {
    fieldsets.push({
      id: 'column2',
      title: `${colorTitle} – 2. ${columnLabel}`,
      fields: rowFieldsRight,
    });
  }

  if (showThirdColumn) {
    fieldsets.push({
      id: 'column3',
      title: `${colorTitle} – 3. ${columnLabel}`,
      fields: rowFieldsThird,
    });
  }

  return {
    title: intl.formatMessage(messages.brandBlockTitle),
    fieldsets,
    properties: {
      columns: {
        title: intl.formatMessage(messages.brandColumnsTitle),
        description: intl.formatMessage(messages.brandColumnsDescription),
        type: 'string',
        choices: [
          ['one', intl.formatMessage(messages.brandColumnsOne)],
          ['two', intl.formatMessage(messages.brandColumnsTwo)],
          ['three', intl.formatMessage(messages.brandColumnsThree)],
        ],
        default: DEFAULTS.columns,
      },
      behavior: {
        title: intl.formatMessage(messages.brandBehaviorTitle),
        description: intl.formatMessage(messages.brandBehaviorDescription),
        type: 'string',
        choices: [
          ['static', intl.formatMessage(messages.brandBehaviorStatic)],
          ['reload', intl.formatMessage(messages.brandBehaviorReload)],
          ['interval', intl.formatMessage(messages.brandBehaviorInterval)],
        ],
        default: DEFAULTS.behavior,
      },
      intervalSeconds: {
        title: intl.formatMessage(messages.brandIntervalTitle),
        description: intl.formatMessage(messages.brandIntervalDescription),
        type: 'number',
        default: DEFAULTS.intervalSeconds,
        minimum: 1,
      },

      row1ColorLeft: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 1,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row1ColorLeft,
      },
      row2ColorLeft: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 2,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row2ColorLeft,
      },
      row3ColorLeft: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 3,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row3ColorLeft,
      },

      row1ColorRight: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 1,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row1ColorRight,
      },
      row2ColorRight: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 2,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row2ColorRight,
      },
      row3ColorRight: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 3,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row3ColorRight,
      },

      row1ColorThird: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 1,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row1ColorThird,
      },
      row2ColorThird: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 2,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row2ColorThird,
      },
      row3ColorThird: {
        title: intl.formatMessage(messages.brandRowColorTitle, {
          row: 3,
        }),
        description: colorDescription,
        type: 'string',
        choices: [
          ['black', intl.formatMessage(messages.brandColorBlack)],
          ['petrol', intl.formatMessage(messages.brandColorPetrol)],
          ['white', intl.formatMessage(messages.brandColorWhite)],
          ['purple', intl.formatMessage(messages.brandColorPurple)],
        ],
        default: DEFAULTS.row3ColorThird,
      },
    },
    required: [],
  };
};

export default Schema;
